import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0711002e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-100"
}
const _hoisted_2 = { class: "subpages" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "h-100"
}
const _hoisted_5 = { class: "case-header" }
const _hoisted_6 = { class: "case-header__items" }
const _hoisted_7 = { class: "case-header__cases-link" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "case-header__icons" }
const _hoisted_11 = { class: "case-user" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "case-user__info" }
const _hoisted_14 = { class: "case-user__info-title" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "case-user__info-name" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "case-main" }
const _hoisted_23 = { class: "case-main__photos" }
const _hoisted_24 = { class: "case-main__info" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-main__info-status" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_drive_photo_carousel = _resolveComponent("drive-photo-carousel")!
  const _component_drive_overview = _resolveComponent("drive-overview")!
  const _component_drive_files = _resolveComponent("drive-files")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!
  const _component_drive_tooltip = _resolveComponent("drive-tooltip")!
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_drive_case_photos = _resolveComponent("drive-case-photos")!
  const _component_app_reorder_photo = _resolveComponent("app-reorder-photo")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_refresh_pull, {
          modelValue: _ctx.loadingPull,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadingPull) = $event)),
          onRefresh: _ctx.onRefresh,
          successText: _ctx.successText,
          pullingText: _ctx.pullingText,
          loosingText: _ctx.loosingText,
          loadingText: _ctx.loadingText
        }, {
          default: _withCtx(() => [
            (!_ctx.isNetwork)
              ? (_openBlock(), _createBlock(_component_drive_shared_bar, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_drive_photo_carousel, {
              class: "photo-carousel",
              onSelectPhoto: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectPhoto($event))),
              onSelectVideo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectVideo($event))),
              "is-swiper": ""
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_drive_overview),
              _createVNode(_component_drive_files)
            ]),
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText"]),
        (_ctx.dataLoading || _ctx.showSkeleton)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
              key: 0,
              title: _ctx.driveStore.currentCase.title,
              "file-skeletons": _ctx.driveStore.currentCase.filesAmount,
              "photo-skeletons": _ctx.driveStore.currentCase.photosAmount
            }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.isNetwork)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
                  }, _toDisplayString(_ctx.$localize('drive.your.cases')), 1))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
                  }, " Network Cases" + _toDisplayString(_ctx.$localize('drive.your.cases')), 1))
            ]),
            _hoisted_8,
            _createElementVNode("div", {
              class: "case-header__title",
              innerHTML: _ctx.descriptionWithLink(_ctx.driveStore.currentCase.title)
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_drive_tooltip, {
              text: "Share case",
              class: "case-header__tooltip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "icon icon-share",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE); _ctx.getPosition($event)})
                })
              ]),
              _: 1
            }),
            _createVNode(_component_drive_tooltip, {
              text: "Save case as copy",
              class: "case-header__tooltip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "icon icon-copy-content",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveCaseAsCopy && _ctx.saveCaseAsCopy(...args)))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_drive_tooltip, {
              text: "Edit case",
              class: "case-header__tooltip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "icon icon-edit",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.editCase && _ctx.editCase(...args)))
                })
              ]),
              _: 1
            }),
            (!_ctx.isNetwork && _ctx.myCase)
              ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                  key: 0,
                  text: "Re-order photo",
                  class: _normalizeClass(["case-header__tooltip", { 'disabled-item': _ctx.photoUploading}])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "icon icon-copy-content",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reorderPhoto && _ctx.reorderPhoto(...args)))
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode(_component_drive_tooltip, {
              text: "Delete case",
              class: "case-header__tooltip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "icon icon-trash",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteCase && _ctx.deleteCase(...args)))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_drive_tooltip, {
              text: "Move case",
              class: "case-header__tooltip item-folder"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "icon icon-move-folder",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openMovePopUp && _ctx.openMovePopUp(...args)))
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "case-user__photo cirlce",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.photoUrl,
              alt: "profile photo"
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$localize('drive.creation.info.person')), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$localize('drive.creation.info.created')), 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$localize('drive.creation.info.updated')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.fullName), 1),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.createdDate), 1),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.updatedDate), 1)
            ])
          ])
        ]),
        (!_ctx.isNetwork)
          ? (_openBlock(), _createBlock(_component_drive_shared_bar, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.uploadInfos.length)
          ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
              key: 1,
              uploadInfo: _ctx.mainStore.getUploadInfo
            }, null, 8, ["uploadInfo"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_drive_case_photos),
            (_ctx.reorderPhotoView)
              ? (_openBlock(), _createBlock(_component_app_reorder_photo, {
                  key: 0,
                  onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reorderPhotoView = false))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_drive_overview),
            _createVNode(_component_drive_files),
            _hoisted_25
          ])
        ]),
        (_ctx.sharedPopUp.item)
          ? (_openBlock(), _createBlock(_component_share_pop_up, {
              key: 2,
              item: _ctx.sharedPopUp.item,
              "item-type": _ctx.sharedPopUp.type,
              positionData: _ctx.positionData,
              onHide: _ctx.closeSharePopUp,
              onSetItemShared: _ctx.setItemShared,
              onSetSharedLabels: _ctx.setSharedLabels,
              onOnShareByMessage: _ctx.removeSharedItemFromStore
            }, null, 8, ["item", "item-type", "positionData", "onHide", "onSetItemShared", "onSetSharedLabels", "onOnShareByMessage"]))
          : _createCommentVNode("", true),
        (_ctx.dataLoading || _ctx.showSkeleton)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
              key: 3,
              title: _ctx.driveStore.currentCase.title,
              "file-skeletons": _ctx.driveStore.currentCase.filesAmount,
              "photo-skeletons": _ctx.driveStore.currentCase.photosAmount
            }, null, 8, ["title", "file-skeletons", "photo-skeletons"]))
          : _createCommentVNode("", true),
        (_ctx.isMoveToCasePopUp)
          ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
              key: 4,
              item: _ctx.driveStore.currentCase!,
              "item-type": _ctx.SHARE_TYPES.CASE,
              onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
              onUpdateLocation: _ctx.updateLocation
            }, null, 8, ["item", "item-type", "onUpdateLocation"]))
          : _createCommentVNode("", true)
      ]))
}